import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';



const lightbox = GLightbox({
   touchNavigation: true,
   loop: true,
   autoplayVideos: true,
});
